import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=59c8a9cc&scoped=true&lang=pug&"
import script from "./BaseTable.vue?vue&type=script&lang=js&"
export * from "./BaseTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseTable.scss?vue&type=style&index=0&id=59c8a9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8a9cc",
  null
  
)

export default component.exports